<template>
  <div class="main">
    <!-- <div class="back" @click="goBack">
      <a-button type="primary"
        ><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button
      >
    </div> -->
    <!-- userStore.roles.includes('carEnterprise') -->
    <div v-if="!userStore.roles.includes('carEnterprise')" class="back"
      @click="router.push('/qualificationManage/review')">
      <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
    </div>

    <div v-else class="back" @click="router.push('/qualificationManage/index')">
      <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
    </div>

    <div class="table" v-if="details">
      <table>
        <tr>
          <td>
            测试类型：<span class="name" v-if="details.category">
              {{
                getSingleTypeValue(
                  appStore.SysDictVOList,
                  "testType" + "category" + details.category
                )
              }}</span>
          </td>
          <td>
            测试区域：<span class="name">{{ details.testZoneNames }}</span>
          </td>
          <td>
            测试车辆车架号：<span class="name">{{ details.carFrameNum }}</span>
          </td>
          <td>
            测试牌照：<span class="name">{{
              details.carTestNum ? details.carTestNum : "无"
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3" rowspan="2">
            测试路线：
            <span class="name">
              {{ details.testZoneDetailNames }}
            </span>
          </td>
          <td>
            驾驶员：<span class="name">{{ details.driverNames }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            安全员：<span class="name">{{ details.securityNames }}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- <div v-if="editType && fileURL" style="cursor: pointer">
      <div class="tab_two_title" style="margin-top: 32px">
        示范区应急预案方案
      </div>
      <a class="file_text" :href="fileURL" target="_blank">
        <div>
          <FileTextOutlined class="file_icon mr16" />
          <a>{{ getFileName(fileURL) }}</a>
        </div>
        <div>
          <i class="iconfont icon-quanbuxiazaiicon" style="color: rgba(24, 111, 242, 1)"></i>
        </div>
      </a>
      <div class="border"></div>
    </div> -->
    <div class="flex jcsb" style="padding-right: 88px">
      <div class="tab_two_title" style="margin-bottom: 18px">
        申请所需材料清单
      </div>
      <a-button type="primary" ghost class="ml24 mt22 mb18" @click="downloadAll"><i
          class="iconfont icon-quanbuxiazaiicon mr5"></i> 全部下载</a-button>
    </div>
    <div class="table">
      <a-table :columns="!editType ? columns : isStatusColumns" :row-key="(record) => record.id"
        :data-source="dataSource" size="middle" :pagination="false">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'ranking'">
            {{ index + 1 }}
          </template>
          <template v-if="column.key === 'tempName'">
            <div>
              <a style="color: #1e8ef2" :href="record.materialTemplateFile" v-if="record.materialTemplateFile"
                target="_blank">{{ getFileName(record.materialTemplateName) }}</a>
            </div>
          </template>

          <template v-if="column.key === 'file'">
            <div style="color: #1e8ef2; margin-bottom: 9px">
              {{ getFileName(record.uploadFile) }}
            </div>
            <div style="color: #636d7b" v-if="record.uploadTime">
              （上传时间：{{
                moment(record.uploadTime).format("YYYY-MM-DD HH:mm:ss")
              }}）
            </div>
          </template>
          <template v-else-if="column.key === 'checkMsg' && editType">
            <a-textarea v-model:value="record.checkMsg" placeholder="请输入（审批通过时此处非必填）" :rows="3" />
          </template>
          <template v-else-if="column.key === 'status' && !editType">
            <span v-if="record.status == null">等待审批</span>
            <span v-if="record.status == 1">通过</span>
            <span v-if="record.status == 0">不通过</span>
          </template>
          <template v-else-if="column.key === 'status' && editType">
            <a-radio-group v-model:value="record.status">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="0">不通过</a-radio>
            </a-radio-group>
          </template>
          <template v-else-if="column.key === 'action' && record.uploadFile">
            <span>
              <a @click="preview(record)">预览</a>
              <a class="ml16" @click="onlyDown(record)" target="_blank">下载</a>
            </span>
          </template>
        </template>
      </a-table>
    </div>
    <div v-if="!editType" class="tab_two_title" style="margin-top: 32px">
      审批结果
    </div>
    <div v-if="!editType" class="table">
      <a-table :columns="resultColumns" :row-key="(record) => record.id" :data-source="resultDataSource" size="middle"
        class="mt23" :pagination="false">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'file'">
            <div style="color: #1e8ef2; margin-bottom: 9px">
              {{ record.file }}
            </div>
            <div style="color: #636d7b" v-if="record.uploadTime">
              （上传时间：
              {{ moment(record.uploadTime).format("YYYY-MM-DD HH:mm:ss") }}）
            </div>
          </template>

          <template v-if="column.key === 'meetingDocuments'">
            <div v-html="getFileList(record.conferenceFiles)" style="color: rgb(30, 142, 242)"></div>
          </template>
          <template v-if="column.key === 'resultDocuments'">
            <div v-html="getFileList(record.resultFiles)" style="color: rgb(30, 142, 242)"></div>
          </template>
          <!-- <template v-else-if="column.key === 'action'">
            <span>
              <a @click="detail(record)">预览</a>
              <a class="ml16" @click="detail(record)">下载</a>
            </span>
          </template> -->
        </template>
      </a-table>
    </div>
    <div v-if="editType" class="footer_file">
      <div class="tit">监管装置接入证明文件，文件格式为PDF</div>
      <div><img src="../../assets/images/pdf_icon.png" alt="" /></div>
      <uploadText pathName="car" @uploadFinished="uploadFinished" />
      <!-- <a-upload v-model:file-list="fileList" name="file" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                :headers="headers" @change="handleChange">
                <div class="file_bg">选择文件</div>
            </a-upload> -->
    </div>

    <a-modal v-model:open="visible" title="Basic Modal" @ok="handleOk">
      <iframe :src="imgVisbleURL" frameborder="0" width="100%" height="600"></iframe>
    </a-modal>

    <div v-if="editType" class="footer">
      <a-button type="primary" ghost>取消</a-button>
      <a-button class="ml61" type="primary" @click="submit">提交</a-button>
    </div>
  </div>
</template>
<script setup name="ExamineDetail">
import { ref, reactive, toRefs, onBeforeMount, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import moment from "moment";
import { message } from "ant-design-vue";
import uploadText from "@/components/uploadText/index.vue";
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import {
  getMaterialList,
  getQualificationInfoDetail,
  getQualificationCheckResults,
  getListByCondition,
  updateQualificationMateriaCheckInfo,
  checkQualificationInfo,
} from "@/api/qualification/index";
import { getSingleTypeValue } from "@/utils/matchDic.js";

import { Base64 } from "js-base64";

const appStore = useAppStore();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

const fileList = ref([]);
const headers = {
  authorization: "authorization-text",
};

const editType = ref(false);

const columns = [
  {
    title: "序号",
    dataIndex: "ranking",
    key: "ranking",
    width: "100px",
  },
  {
    title: "附件名称",
    dataIndex: "materialTemplateName",
    key: "materialTemplateName",
    width: "30%",
    ellipsis: true,
  },
  {
    title: "材料文件",
    dataIndex: "file",
    key: "file",
    width: "30%",
  },
  {
    title: "审批状态",
    key: "status",
    dataIndex: "status",
    width: "15%",
  },
  {
    title: "文件预览/下载",
    key: "action",
    width: "200px",
  },
];

//材料审核时的表头
const isStatusColumns = [
  {
    title: "序号",
    dataIndex: "ranking",
    key: "ranking",
    width: "100px",
  },
  {
    title: "附件名称",
    dataIndex: "materialTemplateName",
    key: "materialTemplateName",
    width: "30%",
    ellipsis: true,
  },
  {
    title: "材料文件",
    dataIndex: "file",
    key: "file",
    width: "20%",
  },
  {
    title: "审批",
    key: "status",
    dataIndex: "status",
    width: "9%",
  },
  {
    title: "审批意见",
    key: "checkMsg",
    dataIndex: "checkMsg",
    width: "25%",
  },
  {
    title: "文件预览/下载",
    key: "action",
    width: "200px",
  },
];

const resultColumns = [
  {
    title: "审批时间",
    dataIndex: "checkResultTime",
    key: "checkResultTime",
  },
  {
    title: "审批人",
    dataIndex: "checkUserName",
    key: "checkUserName",
  },
  {
    title: "审核结果",
    dataIndex: "checkResult",
    key: "checkResult",
  },
  {
    title: "审核意见",
    dataIndex: "checkResultMsg",
    key: "checkResultMsg",
    width: "35%",
  },
  {
    title: "审核会议文件",
    dataIndex: "meetingDocuments",
    key: "meetingDocuments",
  },
  {
    title: "审核结果文件",
    dataIndex: "resultDocuments",
    key: "resultDocuments",
  },
];

route.query.type == "edit" ? (editType.value = true) : (editType.value = false);

if (route.query.id) {
  getDetail();
  getMaterials();
  if (!editType.value) {
    getResule();
  }
}

//返回路由    1 qualificationManage/index;
let backUrl = route.query.from;

// 获取详情
let details = ref();

let dataSource = ref([]);

let resultDataSource = ref([]);

function getDetail() {
  getQualificationInfoDetail({ id: route.query.id }).then((res) => {
    details.value = res.data;
  });
}

function getMaterials() {
  getMaterialList({ qualificationsId: route.query.id }).then((res) => {
    dataSource.value = res.data;
  });
}

function getResule() {
  getQualificationCheckResults({ id: route.query.id }).then((res) => {
    resultDataSource.value = res.data;
  });
}

const downloadFileUrl = (url, fileName) => {
  // url 是地址、fileName
  let aUrl = url;
  const x = new XMLHttpRequest();
  x.open("GET", aUrl, true);
  x.responseType = "blob";
  x.onload = function () {
    const url = window.URL.createObjectURL(x.response);
    const elink = document.createElement("a");
    elink.href = url;
    elink.download = `${fileName}`;
    elink.style.display = "none";
    document.body.appendChild(elink);
    setTimeout(() => {
      elink.click();
      document.body.removeChild(elink);
    }, 66);
  };
  x.send();
};

const down = (row) => {
  let url = row.uploadFile;
  let arr = (row.uploadFile + "").split("/car/");
  downloadFileUrl(url, arr[1]);
};

const downloadAll = () => {
  let copyDataSource = JSON.parse(JSON.stringify(dataSource.value));
  let res = copyDataSource.filter((item) => item.uploadFile !== null);
  if (res.length == 0) {
    message.warning("请选择文件");
    return false;
  }
  let timer = setInterval(() => {
    if (res.length == 0) {
      clearInterval(timer);
      return false;
    }
    down(res[0]);
    res.splice(0, 1);
  }, 1200);
};

const onlyDown = (record) => {
  down(record)
}


const visible = ref(false);
const imgVisbleURL = ref(null);
// 预览
const preview = (record) => {
  // 当前页面 在线预览
  //   imgVisbleURL.value = 'http://192.168.3.35:8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(record.uploadFile))
  //   visible.value = true
  let url = "";
  // 开发环境
  if (process.env.NODE_ENV == "development") {
    console.log(window.location);
    url = process.env.VUE_APP_PREVIEW_URL;
  } else if (process.env.NODE_ENV == "production") {
    //生产环境
    url = 'http://192.168.74.107:8080' + "/file-online-preview" + "/onlinePreview?url=";   // 5127
    // url = 'http://124.221.243.22:8012' + "/onlinePreview?url=";   // 5127
    // url = 'http://124.70.161.33:9008' + "/kkFileView/onlinePreview?url=";  // 5138
    // url = window.location.origin + "/api/file-online-preview" + "/kkFileView/onlinePreview?url=";
  }
  // 在线预览 跳转新页面
  window.open(url + encodeURIComponent(Base64.encode(record.uploadFile)));
};

const handleOk = () => {
  visible.value = false;
};

const handleChange = (info) => {
  if (info.file.status !== "uploading") {
    console.log(info.file, info.fileList);
  }
  if (info.file.status === "done") {
    message.success(`${info.file.name} file uploaded successfully`);
  } else if (info.file.status === "error") {
    message.error(`${info.file.name} file upload failed.`);
  }
};

const getFileName = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }

  let arr = url.split("/");
  let file = arr[arr.length - 1];

  // 如果文件名包含点号且不以点号开头，则截取掉后缀
  const dotIndex = file.lastIndexOf(".");
  if (dotIndex > 0) {
    return file.substring(0, dotIndex);
  }

  return file;
};

//示范区应急预案方案
const fileURL = ref();
const getFileUrl = () => {
  getListByCondition({ funcCode: "qualification_emergency_plan" }).then(
    (res) => {
      fileURL.value = res.data[0]?.url;
    }
  );
};
getFileUrl();

const goBack = () => {
  // if(backUrl==1){
  //     router.push('/qualificationManage/review')
  // }else{
  //     router.push('/qualificationManage/review')
  // }
  router.go(-1);
};

const testType = ref([]);
function categoryTxt(val) {
  if (val) {
    let obj = testType.value.find((e) => e.dataCode == val);
    console.log(obj);
    return obj.dataValue;
  }
}

//监管装置文件上传成功
const monitorFile = ref();
const uploadFinished = (url) => {
  console.log(url, 1111);
  monitorFile.value = url;
};

//提交
const submit = () => {
  console.log(dataSource.value);
  let checkMaterialList = [];

  if (
    dataSource.value.findIndex(
      (target) => target.status == null
    ) !== -1
  ) {
    message.warning("材料清单需全部勾选后才能点击提交");
    console.log("验证不通过");
    return false;
  }

  if (
    dataSource.value.findIndex(
      (target) => target.status == 0 && !target.checkMsg
    ) !== -1
  ) {
    message.warning("不通过时，请填写相关审批意见");
    console.log("验证不通过");
    return false;
  }
  console.log(dataSource.value);

  dataSource.value.map((item) => {
    // if ((item.status == 0 || item.status == null) && !item.checkMsg) {
    //   message.warning("不通过时，请填写相关审批意见");
    //   return false;
    // }
    checkMaterialList.push({
      id: item.id,
      status: item.status,
      checkMsg: item.checkMsg,
    });
  });
  let obj = {
    checkMaterialList: checkMaterialList,
    qualificationId: route.query.id,
    monitorFile: monitorFile.value,
    ryUserId: userStore.id,
  };
  console.log(obj);
  updateQualificationMateriaCheckInfo(obj).then((res) => {
    console.log(res);
    if (res.code == 200) {
      message.success("成功");
      router.push("/qualificationManage/review");
    }
  });
};

const getFileList = (list) => {
  let htm = "";
  list?.map((item) => {
    let name = item.split("/");
    let a = `<a href="${item}" target="_blank">${name[name.length - 1]
      }</a><br>`;
    htm += a;
  });
  return htm;
};

onMounted(async () => {
  console.log(editType.value, "route");
  //获取测试类型字典数据
  testType.value = await appStore.getSysDictVOList("测试类型");
});
</script>
<style lang="less" scoped>
.main {
  padding: 20px 20px 37px 20px;
  // height: calc(100vh - 70px - 57px);
  background-color: #ffffff;

  .back {
    position: fixed;
    top: 93px;
    right: 50px;
  }
}

.table {
  padding: 0 66px;

  table {
    width: 100%;

    td {
      border: 1px solid #e1e7ef;
      padding: 17px 0 11px 28px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #636d7b;
      text-align: left;
    }

    .name {
      color: rgba(29, 33, 41, 1);
    }

    .table_action {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #186ff2;
    }
  }
}

.tab_two_title {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  margin: 28px 0 24px 0;
  position: relative;
  padding-left: 59px;

  &::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 13px;
    border-radius: 4px;
    background: #1e8ef2;
    position: absolute;
    left: 49px;
    top: 1px;
  }
}

.file_text {
  width: 825px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #636d7b;
  padding: 0 0 0 66px;

  .file_icon {
    font-size: 18px;
    color: rgba(24, 111, 242, 1);
  }
}

.border {
  width: 800px;
  border-bottom: 1px solid #d9e5f4;
  margin: 11px 0 0 49px;
}

.footer_file {
  width: 516px;
  height: 158px;
  background: rgba(246, 248, 250, 1);
  margin: 58px auto 85px auto;
  text-align: center;
  padding: 16px 0 24px 0;

  .tit {
    margin-bottom: 8px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #636d7b;
  }

  .file_bg {
    width: 100px;
    height: 32px;
    line-height: 32px;
    margin-top: 8px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #636d7b;
    cursor: pointer;
  }
}

.footer {
  text-align: center;
}

.ml61 {
  margin-left: 61px;
}

a {
  color: rgba(30, 142, 242, 1);
}

.ml16 {
  margin-left: 16px;
}

.mb16 {
  margin-bottom: 16px;
}

.mt22 {
  margin-top: 22px;
}

.mb18 {
  margin-bottom: 18px;
}

.mr16 {
  margin-right: 16px;
}

/deep/.ant-radio-wrapper {
  margin-top: 10px;
}
</style>
